import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';

/**
 * 控制器模块 - 封装 OrbitControls 轨道控制器
 * 支持鼠标拖拽旋转、滚轮缩放、右键平移
 */
export class Controls {
  /** @type {OrbitControls | null} */
  controls = null;

  /**
   * @param {THREE.Camera} camera - 相机实例
   * @param {THREE.WebGLRenderer} renderer - 渲染器实例
   */
  constructor(camera, renderer) {
    this.controls = new OrbitControls(camera, renderer.domElement);
    this.#init();
  }

  #init() {
    const { controls } = this;

    // 启用阻尼效果（惯性滑动），操作更平滑
    controls.enableDamping = true;
    controls.dampingFactor = 0.08;

    // 旋转速度
    controls.rotateSpeed = 0.8;
    // 缩放速度
    controls.zoomSpeed = 1.2;
    // 平移速度
    controls.panSpeed = 0.8;

    // 最小/最大缩放距离
    controls.minDistance = 1;
    controls.maxDistance = 50;

    // 垂直旋转角度限制（防止翻转到底部以下）
    controls.minPolarAngle = Math.PI * 0.1;
    controls.maxPolarAngle = Math.PI * 0.9;

    // 右键平移
    controls.enablePan = true;
  }

  /** 在每帧渲染循环中调用，更新阻尼状态 */
  update() {
    this.controls?.update();
  }

  /**
   * 设置轨道控制器焦点（目标点）
   * @param {number} x
   * @param {number} y
   * @param {number} z
   */
  setTarget(x, y, z) {
    this.controls?.target.set(x, y, z);
    this.controls?.update();
  }

  /** 重置相机到默认位置和朝向 */
  resetCamera() {
    if (!this.controls) return;
    this.controls.target.set(0, 1, 0);
    this.controls.object.position.set(0, 1.5, 5);
    this.controls.update();
  }

  /** 销毁控制器，释放事件监听 */
  dispose() {
    this.controls?.dispose();
  }
}
